var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.menuAtivo,
            expression: "menuAtivo",
          },
        ],
        staticClass: "container-telas",
      },
      [
        _c(
          "div",
          {
            staticStyle: {
              display: "flex",
              "flex-direction": "column",
              "min-height": "100dvh",
            },
          },
          [
            _c(
              "div",
              { staticStyle: { "flex-grow": "1", "overflow-y": "auto" } },
              [
                _c("div", { staticClass: "header-tela" }, [
                  _c("i", {
                    staticClass: "fa-solid fa-angle-down me-3",
                    style: { color: _vm.primaryColor },
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.nomeItem))]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.step == 1,
                        expression: "step == 1",
                      },
                    ],
                    staticStyle: { "padding-top": "30px", width: "100%" },
                  },
                  [
                    _c("input-data-calendario", {
                      staticStyle: {
                        "margin-top": "20px",
                        "padding-left": "30px",
                        "padding-right": "30px",
                      },
                      attrs: {
                        "passeio-id": _vm.passeioId,
                        "is-mobile": true,
                        "initial-available-days": _vm.initialAvailableDays,
                      },
                      model: {
                        value: _vm.selectedDate,
                        callback: function ($$v) {
                          _vm.selectedDate = $$v
                        },
                        expression: "selectedDate",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.loadingAvailability,
                            expression: "loadingAvailability",
                          },
                        ],
                        staticStyle: {
                          "text-align": "center",
                          "margin-top": "10px",
                        },
                      },
                      [_c("i", { staticClass: "fa-regular fa-hourglass" })]
                    ),
                    _vm._v(" "),
                    _c("input-horario", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.loadingAvailability && _vm.selectedDate,
                          expression: "!loadingAvailability && selectedDate",
                        },
                      ],
                      staticStyle: {
                        "margin-top": "20px",
                        "border-bottom": "1px solid #dfdfdf",
                      },
                      attrs: {
                        horarios: _vm.horarios,
                        "selected-quantities": _vm.selectedAgeRanges,
                        "primary-color": _vm.primaryColor,
                        "is-mobile": true,
                        "show-remaining-vacancies": _vm.showRemainingVacancies,
                        "passeio-tipo": _vm.passeioTipo,
                        "genero-titulo-atividade": _vm.generoTituloAtividade,
                        "titulo-atividade": _vm.tituloAtividade,
                      },
                      model: {
                        value: _vm.selectedAvailability,
                        callback: function ($$v) {
                          _vm.selectedAvailability = $$v
                        },
                        expression: "selectedAvailability",
                      },
                    }),
                    _vm._v(" "),
                    _c("input-tickets", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            !_vm.loadingAvailability &&
                            _vm.selectedDate &&
                            _vm.selectedAvailability,
                          expression:
                            "!loadingAvailability && selectedDate && selectedAvailability",
                        },
                      ],
                      attrs: {
                        options: _vm.ageRanges,
                        "selected-date": _vm.selectedDate,
                        "primary-color": _vm.primaryColor,
                        min: _vm.quantidadeMinVenda,
                        max: _vm.quantidadeMaxVenda,
                        "is-mobile": true,
                        moeda: _vm.$props.moeda,
                        "nome-item": _vm.$props.nomeItem,
                        available: _vm.horarios,
                        "selected-availability": _vm.selectedAvailability,
                        "tipo-passeio": _vm.passeioTipo,
                        "cobrar-taxa": _vm.cobrarTaxa,
                        taxa: _vm.taxa,
                      },
                      on: {
                        "on-complience-state-change": _vm.complienceChange,
                      },
                      model: {
                        value: _vm.selectedAgeRanges,
                        callback: function ($$v) {
                          _vm.selectedAgeRanges = $$v
                        },
                        expression: "selectedAgeRanges",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.step == 2,
                        expression: "step == 2",
                      },
                    ],
                    staticStyle: {
                      "padding-top": "30px",
                      "padding-left": "30px",
                      "padding-right": "30px",
                    },
                  },
                  [
                    _c(
                      "strong",
                      {
                        staticStyle: {
                          "font-size": "25px",
                          "line-height": "28px",
                        },
                        style: { color: _vm.primaryColor },
                      },
                      [
                        _vm._v(
                          "\n            Melhore sua experiência\n          "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-size": "25px",
                          "line-height": "26px",
                        },
                      },
                      [_vm._v("com nossos opcionais")]
                    ),
                    _vm._v(" "),
                    _c("input-opcionais", {
                      staticStyle: { "margin-top": "20px" },
                      attrs: {
                        "selected-date": _vm.selectedDate,
                        max: _vm.nPessoas,
                        "primary-color": _vm.primaryColor,
                        "mobile-mode": true,
                        "passeio-id": _vm.passeioId,
                        moeda: _vm.$props.moeda,
                      },
                      on: {
                        "optionals-availability-change": (av) =>
                          (_vm.hasOptionalsAvailable = av),
                      },
                      model: {
                        value: _vm.selectedOptionals,
                        callback: function ($$v) {
                          _vm.selectedOptionals = $$v
                        },
                        expression: "selectedOptionals",
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { "padding-bottom": "5%" } },
              [
                _c("resumo-compra-mobile", {
                  attrs: {
                    "current-total":
                      _vm.subtotal + _vm.totalOpcionais + _vm.totalTaxa,
                    "current-total-desconto":
                      _vm.totalDesconto +
                      _vm.totalOpcionais +
                      _vm.totalTaxaDesconto,
                    preco: _vm.preco,
                    "preco-original": _vm.precoOriginal,
                    "preco-desconto": _vm.precoDesconto,
                    "display-mode": !_vm.menuAtivo,
                    "primary-color": _vm.primaryColor,
                    "can-advance": _vm.canAdvance,
                    submitting: _vm.isSubmitting,
                    "menu-active": _vm.menuAtivo,
                    moeda: _vm.$props.moeda,
                    "preco-label": _vm.precoLabel,
                    price: true,
                    "discount-by-payment-method":
                      _vm.$props.discountByPaymentMethod,
                    "discount-payment-methods-label":
                      _vm.$props.discountPaymentMethodsLabel,
                  },
                  on: {
                    iniciar: function ($event) {
                      _vm.menuAtivo = true
                    },
                    avancar: _vm.avancar,
                    voltar: _vm.voltar,
                  },
                }),
              ],
              1
            ),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    !_vm.menuAtivo
      ? _c(
          "div",
          { staticClass: "footer-container" },
          [
            _c("resumo-compra-mobile", {
              attrs: {
                "current-total":
                  _vm.subtotal + _vm.totalOpcionais + _vm.totalTaxa,
                "current-total-desconto":
                  _vm.totalDesconto +
                  _vm.totalOpcionais +
                  _vm.totalTaxaDesconto,
                preco: _vm.preco,
                "preco-original": _vm.precoOriginal,
                "preco-desconto": _vm.precoDesconto,
                "display-mode": !_vm.menuAtivo,
                "primary-color": _vm.primaryColor,
                "can-advance": _vm.canAdvance,
                submitting: _vm.isSubmitting,
                "menu-active": _vm.menuAtivo,
                moeda: _vm.$props.moeda,
                "preco-label": _vm.precoLabel,
                "discount-by-payment-method":
                  _vm.$props.discountByPaymentMethod,
                "discount-payment-methods-label":
                  _vm.$props.discountPaymentMethodsLabel,
              },
              on: {
                iniciar: function ($event) {
                  _vm.menuAtivo = true
                },
                avancar: _vm.avancar,
                voltar: _vm.voltar,
              },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }